module.exports = __webpack_public_path__ + "media/coronaTransport.31908208.mp4";